module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "foot"
  }, [_c('dl', [_c('dt', {
    staticClass: "fo fo1"
  }, [_vm._v("关于我们")]), _vm._v(" "), _c('dd', [_c('p', [_c('a', {
    attrs: {
      "href": "https://moorhenknow.top/help"
    }
  }, [_vm._v("交易账号")])])]), _c('dd', [_c('p', [_c('a', {
    attrs: {
      "href": "https://moorhenknow.top/help"
    }
  }, [_vm._v("联系我们")])])])]), _vm._v(" "), _c('dl', [_c('dt', {
    staticClass: "fo fo2"
  }, [_vm._v("帮助中心")]), _vm._v(" "), _c('dd', [_c('p', [_c('a', {
    attrs: {
      "href": "https://moorhenknow.top/help"
    }
  }, [_vm._v("如何购买账号")])])]), _c('dd', [_c('p', [_c('a', {
    attrs: {
      "href": "https://moorhenknow.top/help"
    }
  }, [_vm._v("如何出售账号")])])]), _c('dd', [_c('p', [_c('a', {
    attrs: {
      "href": "https://moorhenknow.top/help"
    }
  }, [_vm._v("如何账号系统回收")])])]), _c('dd', [_c('p', [_c('a', {
    attrs: {
      "href": "https://moorhenknow.top/help"
    }
  }, [_vm._v("更多帮助")])])])]), _vm._v(" "), _c('dl', [_c('dt', {
    staticClass: "fo fo3"
  }, [_vm._v("关注我们")]), _vm._v(" "), _c('dd', [_c('p', [_c('img', {
    staticClass: "fr-fic fr-dii",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "src": require("./images/20220626152956_23461.png")
    }
  })])])]), _vm._v(" "), _c('dl', [_c('dt', {
    staticClass: "fo fo4"
  }, [_vm._v("支付方式")]), _vm._v(" "), _c('dd', [_c('p', [_vm._v("在线支付")])]), _c('dd', [_c('p', [_vm._v("银行汇款")])]), _c('dd', [_c('p', [_vm._v("微信支付")])]), _c('dd', [_c('p', [_vm._v("支付宝支付")])])]), _vm._v(" "), _c('dl', [_c('dt', {
    staticClass: "fo fo5"
  }, [_vm._v("服务与支持")]), _vm._v(" "), _c('dd', [_c('p', [_vm._v("客服电话 0063-9094666666")])]), _c('dd', [_c('p', [_vm._v("客服QQ 暂无")])]), _c('dd', [_c('p', [_vm._v("易信客服 暂无")])])])]), _vm._v(" "), _c('div', {
    staticClass: "foot_text"
  }, [_vm._v("Copyright ©GALAXY TM永利高 Reserved")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69ec988b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/different/yongligao/footer/footer.vue
// module id = 634
// module chunks = 31